<template>
  <div class="w-100 pv2 pv3-ns ph3 mr2-l">
    <h1 class="bg-black-90 white fw2 f5 f4-ns ttu pv1 ph3 mt3">{{ $t("app.recommended") }}</h1>
    <div class="h-75 flex flex-wrap justify-center">
      <div v-show="loading" class="flex justify-center h5 w-100 mv3">
        <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
      </div>
      <div v-show="!loading" class="track-container bg-primary w-100 textColor" v-for="track in promotion"
          :track-by="track.id"
          :key="track.id">
        <track-card :track="track" :inHome="true" class="w-100" @play="playTrack(track); setPlaylist(promotion)" />
      </div>
    </div>
  </div>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import TrackCard from '@/components/tracks/TrackCard.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'recommended',
  data () {
    return {
      color: '#808080',
      size: '30px'
    }
  },
  components: {
    ClipLoader,
    TrackCard
  },
  computed: {
    ...mapGetters('track', [
      'promotion'
    ]),
    loading () {
      return this.$loading.isLoading('track getPromotion')
    }
  },
  methods: {
    ...mapActions('player', [
      'changeTrack',
      'setPlaylist',
      'setPlaying'
    ]),
    playTrack (track) {
      if (this.currentTrack !== track) {
        this.changeTrack(track)
      } else {
        this.setPlaying(true)
      }
    }
  }
}
</script>

<style scoped lang="scss">

.track-container {
  margin-top: 1.5%;
  margin-bottom: 1.5%;
}

</style>



// WEBPACK FOOTER //
// src/components/home/Recommended.vue